﻿<template>
  <div class="ms-input ms-editor w-100" :class="{'ms-validate': isValidate}">
    <label class="label" v-if="label">{{ label }}</label>
    <div
      class="flex-row"
      :class="[
        {error: errorMessage && displayError, disabled: disabled},
        hasBorder ? 'border' : '',
        heightOption == 1 ? 'h-24' : '',
        errorMessage && displayError ? 'display-error' : '',
      ]"
    >
      <div
        :class="['icon24 icon left', leftIcon]"
        v-if="leftIcon"
        v-tooltip="leftIconTooltip"
        :title="errorProvider.message"
      ></div>

      <input
        v-if="trimModel"
        :title="internalText"
        :type="type"
        class="ms-input-item flex w-100"
        :placeholder="placeholder"
        v-model.trim="internalText"
        :disabled="disabled"
        :readOnly="readOnly"
        :maxlength="maxLength"
        :autocomplete="autocomplete"
        ref="input"
        :class="[
          {disabled: disabled},
          hasBorder ? dbOptionHeight + '-border' : dbOptionHeight,
          textAlign ? textAlign : '',
        ]"
        v-on="listeners"
      />

      <input
        v-else
        :type="type"
        :title="internalText"
        class="ms-input-item flex w-100"
        :placeholder="placeholder"
        v-model="internalText"
        :disabled="disabled"
        :readOnly="readOnly"
        :maxlength="maxLength"
        :autocomplete="autocomplete"
        ref="input"
        :class="[
          {disabled: disabled},
          hasBorder ? dbOptionHeight + '-border' : dbOptionHeight,
          textAlign ? textAlign : '',
        ]"
        v-on="listeners"
      />

      <div
        :class="['ic-right', 'ic-right-' + (hasBorder ? dbOptionHeight + '-border' : dbOptionHeight)]"
        v-if="rightIcon"
      >
        <div :class="['icon24 icon', rightIcon]" v-tooltip="rightIconTooltip" @click="onClickRightIcon"></div>
      </div>
      <slot name="second-ic-right"> </slot>
    </div>
    <div class="error-text" v-if="errorMessage && displayError">
      {{ errorMessage }}
      <slot name="error-extend"></slot>
    </div>
  </div>
</template>
<script>
import {defineComponent, ref, onMounted, computed, watch, nextTick, getCurrentInstance} from 'vue';
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import {useValidateControl} from '@/setup/validateControl.js';
import AlertRiskCustomerVendorPopup from '@/views/tax/tARiskCustomerVendor/AlertRiskCustomerVendorPopup.vue';
export default defineComponent({
  extends: msBaseComponent,
  components: {
    AlertRiskCustomerVendorPopup,
  },
  name: 'msInput',
  props: {
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    modelValue: {
      default: null,
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    //icon left
    leftIcon: {
      default: null,
      type: String,
    },
    //icon left tooltip
    leftIconTooltip: {
      default: null,
      type: String,
    },
    //icon right
    rightIcon: {
      default: null,
      type: String,
    },
    //icon right tooltip
    rightIconTooltip: {
      default: '',
      type: String,
    },
    //icon right
    type: {
      default: 'text',
      type: String,
    },
    //Giới hạn nhập của ô input
    maxLength: {
      default: null,
      type: Number,
    },
    //disabled
    disabled: {
      default: false,
      type: Boolean,
    },
    // Xác định xem input có border hay không?
    hasBorder: {
      default: true,
      type: Boolean,
    },
    /*
     * Hàm show ra câu thông báo riêng theo từng trường hợp
     * pvduy 18/03/2021
     * ví dụ: customWarring {rules:'required', mes: 'Tài sản này là của pvduy'}
     */
    customWarring: {
      type: Object,
      default: null,
    },
    /**
     * Có được click icon hay không?
     * NNLINH 27.06.2022
     */
    isClickRightIcon: {
      default: false,
      type: Boolean,
    },
    trimModel: {
      default: false,
      type: Boolean,
    },
    /** Regex nhập */
    regexMask: {
      default: null,
      type: RegExp,
    },
    title: {
      default: null,
      type: String,
    },
    validateMissingValue: {
      type: Boolean,
      default: false,
    },
    ignoreValidate: {
      type: Boolean,
      default: false,
    },
    textAlign: {
      type: String,
      default: null,
    },
    preventPaste: {
      type: Boolean,
      default: false,
    },
    /**
     * config autofill của browser
     */
    autocomplete: {
      default: null,
      type: String,
    },
  },
  emits: ['msKeydown', 'update:modelValue', 'focus', 'blur', 'change', 'msKeyup', 'clickRightIcon'],
  setup(props, {emit}) {
    //Variable
    let internalText = ref('');
    let focused = false;
    let displayValue = null;
    let scrollWidth = 0;
    let input = ref(null);
    let isShowRiskPopup = ref(false);

    const {
      errorMessage,
      validate,
      isValidate,
      clearValidate,
      displayError,
      riskWarningCustomerVendorMessage,
      isShowQuestionIcon,
    } = useValidateControl({
      props,
    });

    const {proxy} = getCurrentInstance();
    //Method
    const hasTooltip = () => {
      if (scrollWidth > input?.value?.offsetWidth) {
        return true;
      }
      return false;
    };
    const dbOptionHeight = computed(() => {
      return 'heightoptionvalue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });
    const heightOption = computed(() => {
      return proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2;
    });
    //Sự kiện focus vào ô input
    const onFocus = e => {
      focused = true;
      emit('focus', internalText.value, e);
    };

    //Sự kiên blur ra ngoài ô input
    const onBlur = e => {
      focused = false;
      validate();
      emit('blur', internalText.value, e);
    };

    /**
     * Sự kiện Click icon bên phải ô Input
     * NNLINH 27.06.2022
     */
    const onClickRightIcon = () => {
      if (props.isClickRightIcon) {
        emit('clickRightIcon');
      }
    };
    //Reset lại giá trị về ban đầu
    const reset = () => {
      internalText.value = '';
      displayValue = null;
    };
    //Set giá trị cho ô input
    const setValue = value => {
      if (proxy.rules) {
        const rule = proxy.rules.find(x => x.name === 'pattern' && x.compareValue === 'phone');
        if (rule && value) {
          value = value.replace(/ /g, '').replace(/\./g, '');
        }
      }
      internalText.value = value;
    };

    //Lấy giá trị ô input
    const getValue = () => {
      return internalText.value;
    };

    /**
     * Hủy lan rộng event
     * HTHIEP 09.02.2022
     */
    const cancelEvent = e => {
      if (e) {
        if (typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
    };

    //Hooks
    //set internalText
    onMounted(() => {
      internalText.value = props.modelValue;
      // console.log(proxy.dbOptions.HeightOption);
    });

    /**
     * Lắng nghe event => thò ra ngoài
     * HTHIEP 11.02.2022: Làm mịn, migration sang vue 3
     */
    const listeners = computed(() => {
      return {
        blur: e => {
          cancelEvent(e);
          onBlur(e);
        },
        focus: e => {
          cancelEvent(e);
          onFocus(e);
        },
        change: e => {
          cancelEvent(e);
          emit('change', e, internalText.value);
        },
        keydown: e => {
          proxy.keyDownInput(e);
        },
        keyup: e => {
          emit('msKeyup', e, internalText.value);
        },
        paste: e => {
          proxy.pasteInput(e);
        },
      };
    });

    /**
     * Lắng nghe xử lý update lại modelValue
     * HTHIEP 11.02.2022: Làm mịn, sửa lại từ vue 2 sang vue 3
     */
    watch(
      () => internalText.value,
      value => {
        if (value !== props.modelValue) {
          emit('update:modelValue', value);
          scrollWidth = input.value.scrollWidth;
        }
      },
    );

    /**
     * Lắng nghe thay đổi modelValue set lại text cho input
     * HTHIEP 11.02.2022: Làm mịn, sửa lại từ vue 2 sang vue 3
     * Modified By NXCHIEN 27.12.2023: ko watch props.modelValue khi chuyển từ null sang ''. Sửa lỗi thông báo để trong khi mở vào form
     */
    watch(
      () => props.modelValue,
      (newVal, oldVal) => {
        if (newVal != oldVal && ((newVal && !oldVal) || (!newVal && oldVal) || (newVal && oldVal))) {
          setValue(newVal);
          if (!props.ignoreValidate) {
            validate();
          }
        }
      },
    );

    /**
     * Xử lý event keydown
     */
    function keyDownInput(e) {
      let check = true;

      if (!e.ctrlKey && e.key?.length == 1 && proxy.regexMask) {
        check = proxy.checkRegex(e, e.key);
      }

      if (check) {
        emit(proxy.$ms.constant.CustomEvent.MsKeydown, e, internalText.value);
      } else {
        e.preventDefault();
      }
    }

    /**
     * Kiểm tra Regex
     * @author nnnam - 13/10/2022
     */
    function checkRegex(e, char) {
      let input = e.target,
        val = input.value,
        len = val.length,
        text = val.substring(0, input.selectionStart) + char;
      val.substring(input.selectionEnd, len);

      let isMatch = proxy.regexMask.test(text);
      return isMatch;
    }

    /**
     * Xử lý paste value
     */
    function pasteInput(e) {
      let char = e.clipboardData.getData('text');

      if (proxy.preventPaste) {
        e.preventDefault();
      }

      if (proxy.regexMask && !proxy.checkRegex(e, char)) {
        e.preventDefault();
      }
    }

    return {
      internalText,
      focused,
      listeners,
      reset,
      hasTooltip,
      displayValue,
      input,
      getValue,
      errorMessage,
      validate,
      isValidate,
      clearValidate,
      onClickRightIcon,
      pasteInput,
      checkRegex,
      keyDownInput,
      displayError,
      dbOptionHeight,
      heightOption,
      riskWarningCustomerVendorMessage,
      isShowRiskPopup,
      isShowQuestionIcon,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsInput.scss';
.ic-right {
  display: none;
  align-items: center;
  width: $input-height;
  justify-content: center;
  border-left: 1px solid $secondary;
}
</style>
